import dayjs from "dayjs";

export const getDaysFromToday = (date: Date) => {
  const today = dayjs();
  return today.diff(date, "day");
};
